/**
 * Estado temporário entre telas do cadastro/recuperação de senha.
 * O e-mail fica no sessionStorage (sobrevive a um reload); a senha só em memória,
 * para entrar automaticamente depois de confirmar o e-mail.
 */
const KEY = 'tc.pendingEmail';
const INVITE_KEY = 'tc.pendingInvite';
const RETURN_KEY = 'tc.returnTo';
let pendingPassword = null;

export const flow = {
  get email() {
    try {
      return sessionStorage.getItem(KEY) ?? '';
    } catch {
      return '';
    }
  },
  set email(value) {
    try {
      if (value) sessionStorage.setItem(KEY, value);
      else sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
  get password() {
    return pendingPassword;
  },
  set password(value) {
    pendingPassword = value || null;
  },
  /** Convite aberto antes do login/cadastro (localStorage: sobrevive a fechar o app no meio do cadastro). */
  get invite() {
    try {
      return localStorage.getItem(INVITE_KEY) ?? '';
    } catch {
      return '';
    }
  },
  set invite(value) {
    try {
      if (value) localStorage.setItem(INVITE_KEY, value);
      else localStorage.removeItem(INVITE_KEY);
    } catch {
      /* ignore */
    }
  },
  /**
   * Tela que a pessoa abriu por um link (push/e-mail) antes de entrar: depois do login volta direto para ela.
   * sessionStorage: vale só nesta aba/sessão.
   */
  get returnTo() {
    try {
      return sessionStorage.getItem(RETURN_KEY) ?? '';
    } catch {
      return '';
    }
  },
  set returnTo(value) {
    try {
      if (value) sessionStorage.setItem(RETURN_KEY, value);
      else sessionStorage.removeItem(RETURN_KEY);
    } catch {
      /* ignore */
    }
  },
  clear() {
    this.email = '';
    pendingPassword = null;
  },
};
